exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sa-success {\n  border: 4px solid #36b729 !important;\n  background-color: #36b729 !important;\n}\n.sa-success-placeholder {\n  border: none !important;\n}\n.sa-success-long, .sa-success-tip {\n  z-index: 5 !important;\n  background-color: #ffffff !important;\n}", ""]);

// exports
